module.exports = __webpack_public_path__ + "00e7c429.png";